import { z } from 'zod';
import { idSchema } from './common';
/**
 * Le référentiel de dégustation.
 *
 * Trois natures de termes que tout membre peut enrichir en séance, sans attendre
 * personne : un rhum du Cap-Vert ne doit pas bloquer une note parce que « Grogue »
 * n'était pas prévu.
 *
 * Les types de rhum n'en font pas partie — ils restent un enum : les quatre valeurs
 * couvrent la production, « Autre » sert de porte de sortie, et le type porte le barème
 * de pronostic.
 */
export const REFERENCE_KINDS = ['COUNTRY', 'STYLE', 'AROMA'];
export const referenceKindSchema = z.enum(REFERENCE_KINDS);
export const REFERENCE_KIND_LABELS = {
    COUNTRY: 'Pays',
    STYLE: 'Style',
    AROMA: 'Descripteur',
};
/** Un libellé trop long n'est plus un descripteur mais un commentaire. */
export const referenceLabelSchema = z
    .string()
    .trim()
    .min(2, 'Deux caractères au moins.')
    .max(60, 'Soixante caractères au plus.');
export const createReferenceTermSchema = z.object({
    kind: referenceKindSchema,
    label: referenceLabelSchema,
    /** Obligatoire pour un descripteur : la roue des arômes n'a que six secteurs. */
    family: z.string().trim().max(40).nullish(),
});
export const renameReferenceTermSchema = z.object({ label: referenceLabelSchema });
/** Fusion : le terme visé absorbe celui-ci, et les fiches existantes sont réécrites. */
export const mergeReferenceTermSchema = z.object({ intoId: idSchema });
export const referenceTermSchema = z.object({
    id: idSchema,
    kind: referenceKindSchema,
    label: z.string(),
    family: z.string().nullable(),
    /** Nombre de fiches ou de notes qui l'emploient — ce qui guide une fusion. */
    usageCount: z.number().int().min(0),
});
//# sourceMappingURL=reference.js.map